import React, { useState, useEffect } from "react";
import styled, { css, createGlobalStyle } from "styled-components";
import Sortable from "./Sortable";
import arrayMove from "array-move";
import produce from "immer";
import AudioPlay from "./AudioPlay";
import { useAudios } from "../hooks/useAudios";
import { ReactComponent as Check } from "../assets/svg/check.svg";
import { ReactComponent as Wrong } from "../assets/svg/wrong.svg";
import clean from "clean-deep";

const LessonDataDiscoverSentence = ({ seed, freeze = false, onChange = () => {} }) => {
  const [state, setState] = useState([]);

  const [extractedAudios, setExtractedAudios] = useState([]);
  const audios = useAudios(extractedAudios);

  useEffect(() => {
    const state = initState(seed);
    setState(state);
    setExtractedAudios(state.map((i) => i.audio));
  }, [seed]);

  useEffect(() => {
    onChange({
      ready: true,
      data: clean(state),
    });
  }, [state, onChange]);

  const isLoaded = ({ audio }) => (audio && audios[audio]) || !audio;

  const onSortEnd = ({ oldIndex, newIndex, indexItem }) =>
    setState(
      produce((draftState) => {
        draftState[indexItem].words = arrayMove(
          draftState[indexItem].words,
          oldIndex,
          newIndex
        );
      })
    );

  return (
    <>
      <GlobalStyles />
      <Container freeze={freeze}>
        {state.map((item, index) => (
          <Row key={index} state={item.state}>
            {isLoaded(item) ? (
              <>
                {item.state && <StateIcon as={stateIcon[item.state]} />}
                {item.audio && <AudioPlay audio={audios[item.audio]} />}
                <Sortable
                  pressDelay={0}
                  axis="xy"
                  items={item.words}
                  render={(value, index) => <Word key={index}>{value}</Word>}
                  wrapper={Words}
                  onSortEnd={(props) =>
                    onSortEnd({ ...props, indexItem: index })
                  }
                  helperClass="helperItem"
                />
              </>
            ) : (
              <Spinner src="loading.gif" />
            )}
          </Row>
        ))}
      </Container>
    </>
  );
};

const stateIcon = {
  SUCCESS: Check,
  FAILURE: Wrong,
};

const initState = (seed) => {
  let state = formatState(seed);
  return state;
};

const formatState = (state) => state.map((state) => ({ words: [], ...state }));

const GlobalStyles = createGlobalStyle`

  .helperItem {
    box-shadow: 0 0 7px 5px rgba(0,0,0,0.1);
    border: 2px dashed green;

    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 200;
  }

`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 20px;
  overflow: hidden;
  background-color: white;
  ${(props) =>
    props.freeze &&
    css`
      pointer-events: none;
    `}
`;

const Row = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px 10px;
  :nth-child(2n) {
    background-color: #fafafa;
  }
  & > * {
    margin: 5px;
  }

  ${(props) =>
    props.state &&
    css`
      padding-bottom: 60px;
    `}
`;

const StateIcon = styled.div`
  width: 25px;
  height: 25px;
  min-width: 25px;
  min-height: 25px;
  position: absolute;
  bottom: 18px;
  left: 0px;
  right: 0px;
  margin: 0 auto;
`;

const Word = styled.div`
  user-select: none;
  font-size: 0.9em;
  background-color: #caedff;
  /*padding: 10px 15px;
  border-radius: 10px;
  margin: 2px;*/

  padding: 20px 25px;
  border-radius: 15px;
  margin: 5px;
  cursor: grab;
`;

const Words = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
`;

const Spinner = styled.img`
  margin: auto;
  width: 25px;
  height: 25px;
  display: block;
`;

export default LessonDataDiscoverSentence;
